import loadable from '@loadable/component';

export SearchMap from './SearchMap';
export const Map = loadable(
	() => import(/* webpackChunkName: "Map" */ './Map'),
);
